export const servicesFaq = () => {
    const servicesBlock = document.querySelector('.services-faq__text-cont')
    const servicesImg = document.querySelector('.services-faq__image img')

    function resizeImg () {
        if (servicesBlock) {
            if (window.innerWidth >= 768) {
                servicesImg.style.height = `${servicesBlock.offsetHeight}px`;
            } else {
                servicesImg.style.height = `auto`;
            }
        }
    }
    resizeImg();
    window.addEventListener('resize', () => {
        resizeImg();
    })
}